import { render, staticRenderFns } from "./GettingStartOliver.vue?vue&type=template&id=2e5f76a8"
import script from "./GettingStartOliver.vue?vue&type=script&lang=js"
export * from "./GettingStartOliver.vue?vue&type=script&lang=js"
import style0 from "./GettingStartOliver.vue?vue&type=style&index=0&id=2e5f76a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports